import Link from 'next/link';
import { type JSX } from 'react';

import { Icon } from '@videoblocks/design-system';

import { KeywordSearchLink } from '../KeywordSearchLink';

/**
 * Yellow banner shown at the top of the results pane when a browse user
 * has reached the conversational search message limit.
 */
export function UsageLimitBanner(): JSX.Element {
    return (
        <div className="m-4 flex flex-col items-end gap-4 rounded-2xl border border-yellow-400 bg-yellow-50 p-4">
            <div className="flex w-full flex-col gap-2">
                <p className="text-xl font-bold text-amber-700">You&apos;ve reached your AI Search limit</p>
                <p className="text-base text-gray-900">
                    Upgrade to access more enhanced search, plus get unlimited downloads and access to creative tools
                </p>
            </div>
            <div className="flex items-start gap-2">
                <KeywordSearchLink className="inline-flex items-center justify-center gap-2 rounded-lg border border-gray-800 px-6 py-2.5 text-sm font-semibold text-gray-800 hover:bg-gray-50 transition-colors">
                    <Icon name="search" className="h-4 w-4" />
                    Try a keyword search instead
                </KeywordSearchLink>
                <Link
                    href="/pricing"
                    data-cta="conv_search_prompt"
                    className="inline-flex items-center justify-center rounded-lg bg-gray-800 px-6 py-2.5 text-sm font-semibold text-white hover:bg-gray-700 transition-colors"
                >
                    Upgrade to continue
                </Link>
            </div>
        </div>
    );
}
